import React, { useState } from "react";
import { CodedProperty, ValidationResult } from "sprint-common-web";

import { UpdateFileRecordAudioSoundtrackRequest } from "../../../../../../../../common/api/master-api/file-records/update/soundtrack/UpdateFileRecordAudioSoundtrackRequest";
import { useFileRecordApi } from "../../../../../../../../common/api/master-api/file-records/useFileRecordApi";
import { ensureAudioFileRecordDetails } from "../../../../../../../common/file-record-details/FileRecordDetails";
import { useFileRecordDetailsState } from "../../../../../hooks/useFileRecordDetailsState";
import { AudioSoundtrackForm } from "./EditSoundtrackForm";

export interface EditSoundtrackAsideContentProps {
    onClose(): void;
}

export const EditSoundtrackAsideContent = (props: EditSoundtrackAsideContentProps): JSX.Element => {
    const { onClose } = props;
    const { fileRecordDetails, setFileRecordDetails } = useFileRecordDetailsState();
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [validationResult, setValidationResult] = useState<ValidationResult>();
    const { updateFileRecordAudioSoundtrack } = useFileRecordApi();

    const updateSoundtrack = (soundtrack?: CodedProperty) => {
        ensureAudioFileRecordDetails(fileRecordDetails);

        const request: UpdateFileRecordAudioSoundtrackRequest = {
            id: fileRecordDetails.id,
            soundtrack: soundtrack ? soundtrack : undefined
        };

        setIsLoading(true);

        updateFileRecordAudioSoundtrack(request)
            .then(() => {
                setFileRecordDetails({
                    ...fileRecordDetails,
                    soundtrack
                });

                onClose();
            })
            .catch((res) => {
                setValidationResult(res);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <AudioSoundtrackForm
            isLoading={isLoading}
            onCancel={onClose}
            onSubmit={updateSoundtrack}
            validationResult={validationResult}
        />
    );
};
